<template>
    <div class="carouselContainer">
        <div class="arrowContainer" @click="prev()">
            <div class="row h-100 justify-content-center align-items-center">
                <i class="fa fa-angle-left fa-3x"></i>
            </div>
        </div>

        <div class="itemsContainer px-3">
            <div class="d-flex flex-row flex-nowrap" ref="scroller" id="scroller">
                <slot ref="contentSlot"></slot>
            </div>
        </div>

        <div class="arrowContainer" @click="next()">
            <div class="row h-100 justify-content-center align-items-center">
                <i class="fa fa-angle-right fa-3x"></i>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CardScroller',
    mounted() {
        this.attachListener();
    },
    methods: {
        attachListener: function() {
            const that = this;
            setTimeout(function() {
                that.callAttacher();
            }, 200);
        },
        scrollTo: function(target) {
            $('#scroller').animate({
                scrollLeft: target
            }, "fast");
        },
        callAttacher: function() {
            const that = this;

            this.scroller = this.$refs.scroller;

            this.scroller.addEventListener('scroll', function(e){
                window.clearTimeout( that.isScrolling );
                // Set a timeout to run after scrolling ends
                that.isScrolling = setTimeout(function() {
                    // Run the callback
                    that.snap();
                }, 200);
            })
        },
        snap: function() {
            var horizontal = this.scroller.scrollLeft;
            let childWidth = this.getChildWidth()
            let div = horizontal /  parseFloat(childWidth);
            let offset = div - Math.floor(div);
            
            // We are already at a snap point. Exit
            if (offset === 0) {
                return;
            }

            let mult = offset >= 0.5 ? Math.ceil(div) : Math.floor(div);
            let target = mult * childWidth;    
        
            this.scrollTo(target);
        },
        prev: function() {
            this.scrollTo(this.scroller.scrollLeft - this.getChildWidth())
        },
        next: function() {
            this.scrollTo(this.scroller.scrollLeft + this.getChildWidth())
        },
        getChildWidth: function() {
            let children = this.scroller.children;

            return children.length === 0 ? 0 : children[0].offsetWidth;
        }
    },
    data() {
        return {
            scroller: undefined,
            isScrolling: undefined
        }
    }
}
</script>

<style lang="scss" scoped>
    $arrow-col-width: 30px;
    .carouselContainer {
        display: flex;
        align-items: center;
        width: 100%;
        height: 100%;
    }

    .arrowContainer {
        width: $arrow-col-width;
        height: 100% !important;
        
    }

    .itemsContainer {
        width: calc(100% - (2 * #{$arrow-col-width}));
    }

    #scroller {
        overflow-x: scroll;
        // overflow:hidden;
        overflow-x: -moz-scrollbars-none;
        -ms-overflow-style: none;
        &::-webkit-scrollbar {
            width: 0 !important;
        }
    }

    .fa {
        color: $primary-color;
        padding: 8px 15px 8px 15px;
        border-radius: $border-radius;
        cursor: pointer;
        -webkit-text-stroke: 3px $white;
    }
</style>